import * as React from "react"
import { Home, Palette, Users, Heart, Images, CalendarDays, CalendarRange, MapPin, GitMerge, Settings2, HelpCircle, FlaskConical, Trash2, Radio } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/donations",
    icon: Heart,
    label: "Donations",
    match: (url) => url.startsWith("/admin/donations"),
  },
  {
    href: "/admin/images",
    icon: Images,
    label: "Images",
    match: (url) => url.startsWith("/admin/images"),
  },
  {
    href: "/admin/daily_listings",
    icon: CalendarDays,
    label: "Daily Listings",
    match: (url) => url.startsWith("/admin/daily_listings"),
  },
  {
    href: "/admin/year_month_listings",
    icon: CalendarRange,
    label: "Year-Month",
    match: (url) => url.startsWith("/admin/year_month_listings"),
  },
  {
    href: "/admin/regions",
    icon: MapPin,
    label: "Regions",
    match: (url) => url.startsWith("/admin/regions"),
  },
  {
    href: "/admin/questions",
    icon: HelpCircle,
    label: "Questions",
    match: (url) => url.startsWith("/admin/questions"),
  },
  {
    href: "/admin/research/recordings",
    icon: FlaskConical,
    label: "Research",
    match: (url) => url.startsWith("/admin/research"),
  },
  {
    href: "/admin/radio_script/new",
    icon: Radio,
    label: "Radio Script",
    match: (url) => url.startsWith("/admin/radio_script"),
  },
  {
    href: "/admin/deletion_requests",
    icon: Trash2,
    label: "Deletions",
    match: (url) => url.startsWith("/admin/deletion_requests"),
    badgeProp: "pending_deletion_requests",
  },
  {
    href: "/admin/merges/new",
    icon: GitMerge,
    label: "Merge",
    match: (url) => url.startsWith("/admin/merges"),
  },
  {
    href: "/admin/site_settings/edit",
    icon: Settings2,
    label: "Site Settings",
    match: (url) => url.startsWith("/admin/site_settings"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/users" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl">{children}</div>
      </main>
    </div>
  )
}
